module.exports = __webpack_public_path__ + "bec4b5496dd5a4967dbeaf7609a1c71e.pdf";